import React from "react";
import { motion } from "framer-motion";

const VALUES_IMG =
  "https://static.prod-images.emergentagent.com/jobs/1244c932-ba4e-452c-af76-86755415d04f/images/05e3cb798169f1b8f75e9da7559f4ec80201944b27fffd14a04b958b58074b18.png";

const VALUES = [
  {
    num: "01",
    title: "Lean by design",
    desc: "No bloat, no feature creep. Every product decision earns its place in the roadmap.",
  },
  {
    num: "02",
    title: "Built to last",
    desc: "We architect for the long run. Products that age well, scale gracefully, and stay relevant.",
  },
  {
    num: "03",
    title: "Deep domain focus",
    desc: "We don't spread thin. Each product we build goes deep into its domain — real expertise, not surface-level solutions.",
  },
  {
    num: "04",
    title: "Global perspective",
    desc: "Products built for everyone, everywhere. We respect the diversity of context, industry, and use.",
  },
];

const WhyAnantora = () => (
  <section
    data-testid="why-anantora-section"
    id="why-anantora"
    style={{
      padding: "clamp(80px, 12vw, 160px) clamp(24px, 6vw, 96px)",
      borderTop: "1px solid #1A1A1A",
    }}
  >
    <div
      style={{ display: "grid", gap: "clamp(48px, 8vw, 100px)", alignItems: "start" }}
      className="grid-cols-1 md:grid-cols-2"
    >
      {/* Left: title + image */}
      <div>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "11px",
            color: "#FF3B00",
            letterSpacing: "0.22em",
            display: "block",
            marginBottom: "14px",
          }}
        >
          [02]
        </span>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true }}
          style={{
            fontFamily: "'Cabinet Grotesk', sans-serif",
            fontWeight: 800,
            fontSize: "clamp(2.8rem, 5vw, 5rem)",
            lineHeight: 0.95,
            letterSpacing: "-0.03em",
            color: "#F4F4F0",
            textTransform: "uppercase",
            margin: "0 0 clamp(32px, 5vw, 56px) 0",
          }}
        >
          Why<br />Anantora
        </motion.h2>

        {/* Architectural image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.9 }}
          viewport={{ once: true }}
          style={{ overflow: "hidden", aspectRatio: "4/3", width: "100%" }}
        >
          <motion.img
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            src={VALUES_IMG}
            alt="Structural integrity — brutalist architecture"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "brightness(0.6) grayscale(0.2)",
              display: "block",
            }}
          />
        </motion.div>
      </div>

      {/* Right: values list */}
      <div style={{ paddingTop: "clamp(0px, 4vw, 60px)" }}>
        {VALUES.map((value, i) => (
          <motion.div
            key={value.num}
            data-testid={`value-item-${value.num}`}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.1, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true }}
            style={{
              display: "grid",
              gridTemplateColumns: "52px 1fr",
              gap: "20px",
              borderBottom: "1px solid #1A1A1A",
              paddingBottom: "clamp(20px, 3vw, 32px)",
              marginBottom: "clamp(20px, 3vw, 32px)",
            }}
          >
            <span
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "11px",
                color: "#FF3B00",
                letterSpacing: "0.1em",
                paddingTop: "3px",
              }}
            >
              [{value.num}]
            </span>
            <div>
              <h3
                style={{
                  fontFamily: "'Cabinet Grotesk', sans-serif",
                  fontWeight: 700,
                  fontSize: "clamp(1rem, 1.5vw, 1.35rem)",
                  color: "#F4F4F0",
                  margin: "0 0 8px 0",
                  letterSpacing: "-0.01em",
                }}
              >
                {value.title}
              </h3>
              <p
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "14px",
                  color: "#666666",
                  lineHeight: 1.7,
                  margin: 0,
                }}
              >
                {value.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyAnantora;
